import React from "react";
import { useState, useEffect, useCallback } from "react";

import TreeView from "@material-ui/lab/TreeView";

import useMounted from "../hooks/useMounted";

import { Auth } from "aws-amplify";
import config from "../config";

import Scrollbar from "../components/Scrollbar";
import Label from "../components/Label";

import eventBus from "../EventBus";

import { contactFlowApi } from "../__fakeApi__/amazon_connect_logs";

import ReactDOM from "react-dom";
import IconSuccess from "../icons/Check";
import IconBan from "../icons/Ban";

import { Tooltip } from "@material-ui/core";

import {
  Modal,
  Box,
  Fade,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";

function SucessTooltip(props) {
  return (
    <Tooltip title={props.message}>
      <IconSuccess />
    </Tooltip>
  );
}

function FailTooltip(props) {
  return (
    <Tooltip title={props.message}>
      <IconBan />
    </Tooltip>
  );
}

export default function TestLogs(props) {
  const mounted = useMounted();
  const [messages, setMessages] = useState([]);

  // Similar to componentDidMount and componentDidUpd
  useEffect(() => {
    try {
      eventBus.on("newExecutionLog", (data) => {
        console.log("new exec : " + data);
        setMessages([]);
        eventBus.remove("newExecutionLog");
      });
    } catch (err) {
      console.error(err);
    }
  }, [eventBus.on]);

  const wsConnect = async () => {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    setWs(new WebSocket(config.WEBSOCKET + "?userId=" + user.username));
  };

  const [ws, setWs] = useState(wsConnect);

  useEffect(() => {
    ws.onopen = () => {
      console.log("log WebSocket Connected");
      // ws.send('client says hi ......');
    };

    ws.onmessage = (e) => {
      const message = e.data;
      console.log("message received ..." + e.data);
      setMessages([message, ...messages]);

      for (let div_lines of document.getElementsByClassName("ace_gutter-cell")) {
        if(!message.includes('tline')){
          // other messages 
          continue;
        }
        let tline = message.split("tline:")[1];
        if (tline == div_lines.firstChild.data) {
          //let resDiv = document.createElement("div");
          //resDiv.setAttribute("class", "resDiv")
          //div_node.appendChild(resDiv)
          //var div_node_react = ReactDOM.findDOMNode(div_lines);
          if (message.includes("SUCCESS")) {
            ReactDOM.render(<SucessTooltip message={message} />, div_lines);
            div_lines.style.color = "green";
          } else {
            ReactDOM.render(<FailTooltip message={message} />, div_lines);
            div_lines.style.color = "red";
          }
        }
      }
    };

    return () => {
      ws.onclose = () => {
        console.log("Executions Log WebSocket Disconnected....re-conecting");
        // re-open the connection if it closes
        setTimeout(function() {
          wsConnect();
        }, 10);
      };
    };
  }, [ws.onmessage, ws.onopen, ws.onclose, messages]);

  if (messages && messages.length > 0) {
    return (
      <Paper elevation={3}>
        <Scrollbar>
          <Box sx={{ minWidth: 700 }}>
            <Table>
              <TableBody>
                {messages
                  .slice()
                  .reverse()
                  .map((message, index) => (
                    <TableRow key={index.toString() + "-TableRow"}>
                      <TableCell key={index.toString() + "-TableCell"}>
                        <Label
                          key={index.toString() + "-Label"}
                          color={
                            message.includes("SUCCESS")
                              ? "success"
                              : message.includes("FAILED")
                              ? "error"
                              : "primary"
                          }
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {message}
                        </Label>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Box>
        </Scrollbar>
      </Paper>
    );
  } else {
    return <TreeView />;
  }
}
